import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import FontAwesome from "react-fontawesome";

const propTypes = {};
const defaultProps = {};

const Link = styled.a`
  font-size: 14px;
  color: #4a4a4a;
  line-height: 16px;
  cursor: pointer;
  text-decoration: underline;
`;

function VideoLink({}) {
  return (
    <Link>
      <FontAwesome
        name="play-circle"
        style={{ color: "#0A9F9B", paddingRight: "5px" }}
      />Watch Video
    </Link>
  );
}

VideoLink.propTypes = propTypes;
VideoLink.defaultProps = defaultProps;

export default VideoLink;



// WEBPACK FOOTER //
// ./src/components/VideoLink/index.js